import { ExtendedOption } from "@/stores/EngineStore/interfaces/ExtendedOption.ts";

export const getExtrasPayload = (extras: ExtendedOption[]) => {
  return extras?.map((e) => ({ extraId: e.id, quantity: e.value }));
};
